import { connect } from 'react-redux'
import { lifecycle, compose, withStateHandlers, branch, renderComponent } from 'recompose'
import { showFilterModal } from 'actions/filterModal'
import withType from 'components/common/hoc/withType'
import { setGlobalSearchView } from 'components/GlobalSearch/actions'
import { getFilterData, getSearchQuery } from 'components/GlobalSearch/selectors'
import BOTGlobalSearch from './BOTGlobalSearch'
import NoResultComponent from './NoResultComponent'
import { checkNoResult } from './helpers'

const withNoResultComponent = branch(
  ({ isNoResult }) => isNoResult,
  renderComponent(NoResultComponent)
)

const mapStateToProps = (state, { title, leftContent }) => ({
  filters: getFilterData(state),
  lastSearch: getSearchQuery(state),
  title,
  isNoResult: checkNoResult(leftContent)
})

const withHeading = withStateHandlers({
  heading: undefined
}, {
  setHeading: () => ({ heading }) => ({ heading })
})

const withSearchLifeCycle = lifecycle({
  componentDidMount() {
    const {
      setGlobalSearchView,
      displayGlobalSearch,
      lastSearch,
      title,
      setHeading
    } = this.props
    setGlobalSearchView(displayGlobalSearch)
    setHeading({ heading: `${title} "${lastSearch}"` })
  },

  componentDidUpdate({ displayGlobalSearch, lastSearch: prevLastSearch, title: prevTitle }) {
    const {
      lastSearch,
      setHeading,
      title
    } = this.props
    if (this.props.displayGlobalSearch !== displayGlobalSearch) {
      this.props.setGlobalSearchView(this.props.displayGlobalSearch)
    }
    if ((!!lastSearch && lastSearch !== prevLastSearch) || (!!title && title !== prevTitle)) {
      setHeading({ heading: `${title} "${lastSearch}"` })
    }
  }
})

export default compose(
  withType({ type: 'BOTGlobalSearch', placeholders: ['leftContent', 'rightContent']}),
  connect(mapStateToProps, { setGlobalSearchView, showFilterModal }),
  withHeading,
  withSearchLifeCycle,
  withNoResultComponent
)(BOTGlobalSearch)
